var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "memorandum_create_block" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          { staticClass: "col-xl-4 col-lg-4 col-sm-12 col-md-12 col-xs-12" },
          [
            _c("left_side_org", {
              attrs: {
                percent_add: _vm.percent_provider,
                has_head_action: _vm.has_head_action,
                provider_type: _vm.provider_type,
                head_action_icon: _vm.head_action_icon,
                show_head_action_title: _vm.has_head_title,
              },
              on: {
                org_loaded: _vm.get_params,
                head_action: _vm.head_action,
                org_change_state: _vm.set_org_state,
                show_base_settings: _vm.show_base_settings,
                create_location: _vm.add_location,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl-8 col-lg-8 col-sm-12 col-md-12 col-xs-12" },
          [
            _c(
              "div",
              { staticClass: "panel", attrs: { id: "panel-50" } },
              [
                _c(
                  "b-overlay",
                  { attrs: { show: _vm.is_load, rounded: "sm" } },
                  [
                    _c("div", { staticClass: "panel-hdr" }, [
                      _c(
                        "h2",
                        [
                          _c("b-form-checkbox", {
                            staticClass: "in_head",
                            attrs: { switch: "", size: "lg" },
                            on: { change: _vm.check_location_all },
                            model: {
                              value: _vm.all_loc_checked,
                              callback: function ($$v) {
                                _vm.all_loc_checked = $$v
                              },
                              expression: "all_loc_checked",
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.__t(
                                  this.provider_type.toUpperCase() +
                                    "_REST_LIST"
                                )
                              ) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "panel-toolbar ml-2" }, [
                        _vm.has_online && _vm.checked_locations.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "mr-4 btn btn-icon btn-sm color-white shadow-0 btn-success waves-effect waves-themed",
                                on: { click: _vm.make_online_batch },
                              },
                              [_c("i", { staticClass: "fal fa-play" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.has_offline && _vm.checked_locations.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "mr-4 btn btn-icon btn-sm color-white shadow-0 btn-info waves-effect waves-themed",
                                on: { click: _vm.make_offline_batch },
                              },
                              [_c("i", { staticClass: "fal fa-stopwatch" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.has_sync && _vm.checked_locations.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "mr-2 btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed",
                                on: { click: _vm.make_sync_batch },
                              },
                              [_c("i", { staticClass: "fal fa-sync" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex position-relative ml-auto",
                            staticStyle: { "max-width": "8rem" },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fal fa-search position-absolute pos-left fs-lg px-2 py-1 mt-1 fs-xs",
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "form-control form-control-sm pl-5",
                              attrs: {
                                id: "input-live",
                                "aria-describedby":
                                  "input-live-help input-live-feedback",
                                placeholder: _vm.__t("SEARCH"),
                                trim: "",
                              },
                              model: {
                                value: _vm.search_param,
                                callback: function ($$v) {
                                  _vm.search_param = $$v
                                },
                                expression: "search_param",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel-container show" }, [
                      _c(
                        "div",
                        { staticClass: "panel-content loc_g" },
                        [
                          _vm._t(
                            "base_location_list",
                            function () {
                              return [
                                _vm.draw_locations.length > 0
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "nav-menu mb-sm-4 mb-md-0 rounded",
                                      },
                                      _vm._l(
                                        _vm.draw_locations,
                                        function (org) {
                                          return _c(
                                            "li",
                                            { staticClass: "location_block" },
                                            [
                                              _c(
                                                "location-item",
                                                _vm._g(
                                                  {
                                                    key: "location_" + org.id,
                                                    attrs: {
                                                      item: org,
                                                      "has-online":
                                                        _vm.has_online,
                                                      "has-offline":
                                                        _vm.has_offline,
                                                      "has-sync": _vm.has_sync,
                                                      "has-sync-update":
                                                        _vm.has_sync_update,
                                                      "has-json": _vm.has_json,
                                                      "has-preview":
                                                        _vm.has_preview,
                                                      "has-busy-mode":
                                                        _vm.has_busy_mode,
                                                    },
                                                  },
                                                  _vm.locationListeners
                                                )
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            },
                            {
                              draw_locations: _vm.draw_locations,
                              listeners: _vm.locationListeners,
                              has_online: _vm.has_online,
                              has_offline: _vm.has_offline,
                              has_sync: _vm.has_sync,
                              has_sync_update: _vm.has_sync_update,
                              has_json: _vm.has_json,
                              has_preview: _vm.has_preview,
                              has_busy_mode: _vm.has_busy_mode,
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("base_aggregator_settings"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }